import Configurator from "../../config/Configurator";
import axios from "axios";
import { shipsSerials } from "../../config/serials.config";

export async function fetchReadSerials(idsArray = null) {
  var userID = localStorage.getItem("userID");

  var res = [];

  try {
    let config = {
      method: "post",
      timeout: 0,
      url:
        (await Configurator()).API_URL +
        "/v2/io/permissions/users/sources/get/get_read_by_user_ids",
      headers: {
        ...axios.defaults.headers.common,
        ...{
          Session: localStorage.getItem("apiKey"),
          "User-Id": userID,
          "Content-Type": "application/json",
        },
      },
      data: JSON.stringify({
        data: {
          userIds: idsArray ?? [parseInt(userID)],
        },
        metadata: {},
      }),
    };
    const response = await axios.request(config);

    console.log("response", response);

    let desiredSerials = response.data.data?.[0]?.sources;

    for (let i = 0; i < desiredSerials.length; i++) {
      const serial = desiredSerials[i];
      const label = shipsSerials[serial] || serial;
      res.push({ serial, label });
    }

    return res;
  } catch (error) {
    console.error("Failed to fetch renamed sensors", error);
    return [];
  }
}
